<template>
  <va-modal
    :value="showModal"
    :noOutsideDismiss="false"
    ref="entitiesByRoleModal"
    :large="true"
    :cancelText="$t('modals.buttons.back')"
    @cancel="closeDeleteModal"
    :showOkay="false"
  >

      <div slot="header" class="modal-title">
        {{user.name}} - {{role.name}}
      </div>
      <div>
        <h5>{{$t('users.roles.entities')}}</h5>
        <ul class="row">
          <li class="col-6" v-for="(entity, index) in entities" :key="index" @click="showEntityDetails(entity)">
            <span class="entity__name__label">
              {{entity.name}} {{entity.cities && entity.cities.length ? '(' + entity.cities.join(', ') + ')' : ''}}
            </span>
          </li>
        </ul>
      </div>
    </va-modal>
</template>
<script>
export default {
  props: {
    entities: {
      type: Array,
      required: false,
      default: () => []
    },
    role: {
      type: Object,
      required: true
    },
    user: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      showModal: false,
    }
  },
  mounted () {
    this.showModal = true
  },
  methods: {
    showEntityDetails: function (entity) {
      this.$router.push({ name: 'adminentities/id', params: { id: entity.id } })
    },
    closeDeleteModal: function () {
      setTimeout(() => {
        this.$emit('entitiesByRoleModalClosed')
      }, 500)
    }
  }
}
</script>

<style scoped lang="scss">
.entity__name__label:hover {
  cursor: pointer;
  text-decoration: underline;
}
</style>
